'use client';

import { useEffect } from 'react';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import ModuleList, {
  ModuleListProps,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import styles from './hotel.module.scss';

export interface HotelProps extends ModuleListProps {
  /** An array of the modules to show */
  modules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const Hotel = ({ modules, personalizationData, trackingData }: HotelProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'hotel' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <ModuleList modules={modules} />
    </div>
  );
};

Hotel.displayName = 'Hotel';

export default Hotel;
